import { useNavigate } from 'react-router-dom';
import { Icon } from '@components/icons';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import { routes } from '@const/routes';
import type { IErrorFallbackProps } from '@components/error_boundary';
import styles from './DevErrorFallback.module.scss';

// Dev-portal-styled fallback for the ErrorBoundary wrapping <Outlet/> in this
// folder's index.tsx — rendered ONLY inside the dev portal shell, so unlike
// the app-root DefaultFallback it can safely lean on the black-gold --dp-*
// tokens (scoped to .wrapper in styles.module.scss) and react-router's
// useNavigate (this fallback never renders outside Router context). "Dev
// portal home" (not "Back to dashboard") to avoid ambiguity with the
// account menu's separate "Back to XEPPT wallet" action.
const DevErrorFallback = (_props: IErrorFallbackProps) => {
    const navigate = useNavigate();

    return (
        <div className={styles.wrapper} role="alert">
            <span className={styles.icon}>
                <Icon name="error_outlined" width={30} height={30} />
            </span>
            <Typography variant="h4" weight="semibold" className={styles.title}>
                Something went wrong
            </Typography>
            <Typography variant="body3" className={styles.description}>
                This page hit an unexpected error. The rest of the dashboard is unaffected —
                try reloading, or head back to your dev portal home.
            </Typography>
            <div className={styles.actions}>
                <Button
                    className={styles.button}
                    variant="outlined-gold"
                    onClick={() => navigate(routes.developers_home)}>
                    Dev portal home
                </Button>
                <Button
                    className={styles.button}
                    variant="gold"
                    onClick={() => window.location.reload()}>
                    Reload page
                </Button>
            </div>
        </div>
    );
};

export default DevErrorFallback;
